import { render, staticRenderFns } from "./CompanyScreen.vue?vue&type=template&id=2a701f58&scoped=true&"
import script from "./CompanyScreen.vue?vue&type=script&lang=js&"
export * from "./CompanyScreen.vue?vue&type=script&lang=js&"
import style0 from "./CompanyScreen.vue?vue&type=style&index=0&id=2a701f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a701f58",
  null
  
)

export default component.exports